module.exports = __webpack_public_path__ + "img/CECA_Mono.Macro.43a25883.png";